<template>
  <div class="breadcrumbs">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in breadcrumbs"
        :key="index"
        :to="item.route"
      >
        {{ item.label }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'PageBreadcrumbs',

  props: {
    breadcrumbs: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.breadcrumbs {
  padding: 0 20px;
  height: 20px;
  background-color: #f2f5f9;
  margin-bottom: 8px;
}

>>> .el-breadcrumb {
  font-size: 12px;
}

>>> .el-breadcrumb__item {
  line-height: 20px;
}

>>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #5c6374;
}

>>> .el-breadcrumb__inner.is-link,
>>> .el-breadcrumb__inner a,
>>> .el-breadcrumb__inner {
  color: #7e8596;
  font-weight: 400;
  font-family: 'Open Sans';
}
</style>



// WEBPACK FOOTER //
// src/common/components/page/PageBreadcrumbs.vue